<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row flex-column-reverse flex-sm-row">
                        <div class="col-md-6">
                            <h2>
                                Your profile
                            </h2>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div>
                            <strong>Motor central key: </strong>{{user_detail.ownerkey}}
                            <br/>
                            <br/>
                        </div>
                        <form @submit.stop.prevent="profileSave">
                            <messages :messages="messages"/>
                            <div class="row">
                                <div class="col-md-12 container-search label-fixed">
                                    <div class="form-row">
                                        <div class="col-md-6 form-group">
                                            <label>Company</label>
                                            <div v-if="user_detail.company">
                                                {{user_detail.company.name}}
                                                <a v-if="$canManageCompany(user_detail.company.id)"
                                                   :href="$laravelRoute('companies.show', user_detail.company_id)">
                                                    (manage)
                                                </a>
                                            </div>
                                        </div>
                                        <b-form-group class="col-md-6"
                                                      label="Email"
                                                      :label-for="getId('email')"
                                                      :state="fieldState('email')"
                                                      :invalid-feedback="invalidField('email')"
                                        >
                                            <b-form-input
                                                :disabled="true"
                                                :id="getId('email')"
                                                type="text"
                                                class="border bg-white"
                                                v-model="user.email"
                                                :state="fieldState('email')"
                                                placeholder="Enter email">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="First Name"
                                                      :label-for="getId('first_name')"
                                                      :state="fieldState('first_name')"
                                                      :invalid-feedback="invalidField('first_name')"
                                        >
                                            <b-form-input
                                                    :id="getId('first_name')"
                                                    type="text"
                                                    v-model="user.first_name"
                                                    :state="fieldState('first_name')"
                                                    placeholder="Enter first name">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Last Name"
                                                      :label-for="getId('last_name')"
                                                      :state="fieldState('last_name')"
                                                      :invalid-feedback="invalidField('last_name')"
                                        >
                                            <b-form-input
                                                    :id="getId('last_name')"
                                                    type="text"
                                                    v-model="user.last_name"
                                                    :state="fieldState('last_name')"
                                                    placeholder="Enter last name">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Phone"
                                                      :label-for="getId('phone')"
                                                      :state="fieldState('phone')"
                                                      :invalid-feedback="invalidField('phone')"
                                        >
                                            <b-form-input
                                                    :id="getId('phone')"
                                                    type="text"
                                                    v-model="user.profile.phone"
                                                    :state="fieldState('phone')"
                                                    placeholder="Enter phone">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Fax"
                                                      :label-for="getId('fax')"
                                                      :state="fieldState('fax')"
                                                      :invalid-feedback="invalidField('fax')"
                                        >
                                            <b-form-input
                                                    :id="getId('fax')"
                                                    type="text"
                                                    v-model="user.profile.fax"
                                                    :state="fieldState('fax')"
                                                    placeholder="Enter fax">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Mobile"
                                                      :label-for="getId('mobile')"
                                                      :state="fieldState('mobile')"
                                                      :invalid-feedback="invalidField('mobile')"
                                        >
                                            <b-form-input
                                                    :id="getId('mobile')"
                                                    type="text"
                                                    v-model="user.profile.mobile"
                                                    :state="fieldState('mobile')"
                                                    placeholder="Enter mobile">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Street address"
                                                      :label-for="getId('address')"
                                                      :state="fieldState('address')"
                                                      :invalid-feedback="invalidField('address')"
                                        >
                                            <b-form-textarea
                                                    :id="getId('address')"
                                                    v-model="user.profile.address"
                                                    row="3"
                                                    :state="fieldState('address')">
                                            </b-form-textarea>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="City"
                                                      :label-for="getId('city')"
                                                      :state="fieldState('city')"
                                                      :invalid-feedback="invalidField('city')"
                                        >
                                            <b-form-input
                                                    :id="getId('city')"
                                                    type="text"
                                                    v-model="user.profile.city"
                                                    :state="fieldState('city')"
                                                    placeholder="Enter city">
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Postcode"
                                                      :label-for="getId('post_code')"
                                                      :state="fieldState('post_code')"
                                                      :invalid-feedback="invalidField('post_code')"
                                        >
                                            <b-form-input
                                                    :id="getId('post_code')"
                                                    type="text"
                                                    v-model="user.profile.post_code"
                                                    :state="fieldState('post_code')"
                                                    placeholder="Enter postcode">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Country"
                                                      :label-for="getId('country_id')"
                                                      :state="fieldState('country_id')"
                                                      :invalid-feedback="invalidField('country_id')"
                                        >
                                            <b-form-select
                                                    :id="getId('country_id')"
                                                    type="text"
                                                    v-model="user.profile.country_id"
                                                    :options="countriesOptions"
                                                    class="form-control"
                                                    :state="fieldState('country_id')">
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <b-btn type="submit" class="btn">Save</b-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div>
                        <form @submit.stop.prevent="passwordChange">
                            <div class="row">
                                <div class="col-md-12 container-search label-fixed">

                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Password"
                                                      :label-for="getId('old_password')"
                                                      :state="fieldState('old_password')"
                                                      :invalid-feedback="invalidField('old_password')"
                                        >
                                            <b-form-input
                                                    :id="getId('old_password')"
                                                    type="password"
                                                    v-model="user.old_password"
                                                    :state="fieldState('old_password')"
                                                    placeholder="Enter old password">
                                            </b-form-input>

                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <b-form-group class="col-md-6"
                                                      label="Password"
                                                      :label-for="getId('password')"
                                                      :state="fieldState('password')"
                                                      :invalid-feedback="invalidField('password')"
                                        >
                                            <b-form-input
                                                    :id="getId('password')"
                                                    type="password"
                                                    v-model="user.password"
                                                    :state="fieldState('password')"
                                                    placeholder="Enter password">
                                            </b-form-input>

                                        </b-form-group>
                                        <b-form-group class="col-md-6"
                                                      label="Confirm password"
                                                      :label-for="getId('password_confirmation')"
                                                      :state="fieldState('password_confirmation')"
                                                      :invalid-feedback="invalidField('password_confirmation')"
                                        >
                                            <b-form-input
                                                    :id="getId('password_confirmation')"
                                                    type="password"
                                                    v-model="user.password_confirmation"
                                                    :state="fieldState('password_confirmation')"
                                                    placeholder="Enter confirm password">
                                            </b-form-input>

                                        </b-form-group>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <b-btn type="submit" class="btn">Save</b-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'
    import BootstrapValidation from '../../mixins/bootstrap-validation';

    export default {
        props: [
            'user_detail',
        ],
        created() {
            this.$store.dispatch('userStatuses/getUserStatuses');
            this.$store.dispatch('userRoles/getUserRoles');
            this.$store.dispatch('countries/getCountries').then(
                (countries) => this.countriesOptions = countries.map(function (country) {
                    return {value: country.id, text: country.name}
                }));
        },
        mixins: [BootstrapValidation],
        data() {
            return {
                user: this.user_detail,
                messages: [],
                countriesOptions: []
            }
        },
        computed: {
            ...mapState({
                countries: state => state.countries.all,
                users: state => state.users.all,
                regions: state => state.region.all,
                statuses: state => state.userStatuses.all,
                attended_auctions: state => state.attendedAuctions.all,
                user_roles: state => state.userRoles.all,
            }),
        },
        methods: {
            objLookup(obj, key) {
                return objLookup(obj, key);
            },
            getId(name) {
                return name;
            },
            async profileSave() {
                this.messages = [];
                this.errors = [];
                try {
                    let response = await this.$store.dispatch('users/updateProfile', this.user);
                    if (response) {
                        this.messages.push({type: 'success', message: response.message});
                        this.errors = [];
                    } else {

                    }
                } catch (error) {
                    console.warn('onSubmit error: ', error);
                    let message = getExceptionErrorMessage(error);
                    this.messages.push({type: 'danger', message});
                    let errors = getHttpValidationErrors(error);
                    if (errors) {
                        this.errors = errors;
                    }
                }
            },
            async passwordChange() {
                this.messages = [];
                this.errors = [];
                try {
                    let data = {
                        old_password: this.user.old_password,
                        password: this.user.password,
                        password_confirmation: this.user.password_confirmation,
                    };
                    let response = await this.$store.dispatch('users/changePassword', data);
                    if (response) {
                        this.messages.push({type: 'success', message: response.message});
                        this.errors = [];
                    } else {

                    }
                } catch (error) {
                    console.warn('onSubmit error: ', error);
                    let message = getExceptionErrorMessage(error);
                    this.messages.push({type: 'danger', message});
                    let errors = getHttpValidationErrors(error);
                    if (errors) {
                        this.errors = errors;
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/User/EditUserProfilePage.vue